import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions, Errors } from 'react-redux-form';
import { Grid, Row, Col, Button, FormGroup } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import { newPassword } from '../../../actions/login';
import TextViewer from '../../common/editor/text-viewer';
import PasswordMaskInput from '../../common/form/elements/password-mask-input';
import './style.css';

class NewPasswordForm extends Component {

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(actions.reset('deep.resetPW.step4'));
  }

  handleSubmit = (payLoad) => {
    const { dispatch, resetType } = this.props;
    dispatch(actions.submitFields('deep.resetPW.step4', newPassword(payLoad, resetType)
      .catch((error) => {

        dispatch({ type: 'NEW_PASSWORD_REJECTED', payLoad: error.response.data });

        const errors = error.response.data.errors;
        dispatch(actions.change('deep.resetPW.step4.password', '', { silent: true }));
        dispatch(actions.change('deep.resetPW.step4.password_confirmation', '', { silent: true }));
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          // ....
        } else {
          return Promise.reject(errors.user);
        }

      })
    ));

  };

  resetErrors = () => {
    this.props.dispatch(actions.resetErrors('deep.resetPW.step4'));
  };

  render() {
    return (
      <Grid fluid className="new-password">

        <Row>
          <Col lg={12}>
            <PageTitle>Please create a new password</PageTitle>
          </Col>
        </Row>
        <TextViewer pageSlug='set-new-password'></TextViewer>
        <Row>
          <Col lg={6}>
            <Form model="deep.resetPW.step4" className="pw-form"
              onChange={(values) => this.resetErrors()}
              onSubmit={(values) => this.handleSubmit(values)}>



              <FormGroup>
                <label htmlFor=".password">Password</label>
                <Control className="form-control"
                  model=".password"
                  component={PasswordMaskInput} />
                <Errors className="errors"
                  model=".password"
                  show={{
                    touched: true,
                    focus: false
                  }} />
              </FormGroup>
              <FormGroup>

                <label htmlFor=".password_confirmation">Confirm password</label>
                <Control className="form-control"
                  model=".password_confirmation"
                  component={PasswordMaskInput} />
                <Errors className="errors"
                  model=".password_confirmation"
                  show={{
                    touched: true,
                    focus: false
                  }} />
              </FormGroup>

              <FormGroup>
                <Errors className="errors" model="deep.resetPW.step4" />
                <Button type="submit"
                  disabled={!this.props.formValid}
                  className="red-btn pull-right submit">
                  Change my password
              </Button>
              </FormGroup>

            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.resetPW.step4.$form.valid
  };
};

export default connect(mapStateToProps)(NewPasswordForm);



// WEBPACK FOOTER //
// ./src/components/auth/new-password/index.jsx